import styled, { AnyStyledComponent } from 'styled-components';

interface WrapperProps {
  width: string;
  height: string;
  transitionSpeed: string;
  initTransitionStyles?: string;
  hoverTransitionStyles?: string;
  classNameOverride?: string;
}

export const ElementHoverWrapper: AnyStyledComponent = styled.div`
    position: relative;
    width: ${({width}: WrapperProps) => width};
    height: ${({height}: WrapperProps) => height};
    >*:last-child {
      opacity: 0;
      z-index: 1;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: ${({transitionSpeed}: WrapperProps) => transitionSpeed}s;
      ${({initTransitionStyles}: WrapperProps) => initTransitionStyles}
    }
    &:hover,
    &:focus,
    &:focus-within {
      >*:last-child {
        opacity: 1;
        ${({hoverTransitionStyles}: WrapperProps) => hoverTransitionStyles}
      }
    }
`;

export const ClassNameHoverWrapper: AnyStyledComponent = styled.div`
    position: relative;
    width: ${({width}: WrapperProps) => width};
    height: ${({height}: WrapperProps) => height};
    .hover-toggle-data {
      opacity: 0;
      z-index: 0;
      transition: ${({transitionSpeed}: WrapperProps) => transitionSpeed}s;
      ${({initTransitionStyles}: WrapperProps) => initTransitionStyles}
    }
    &:hover,
    &:focus,
    &:focus-within {
      .hover-toggle-data {
        z-index: 1;
        opacity: 1;
        ${({hoverTransitionStyles}: WrapperProps) => hoverTransitionStyles}
      }
    }
`;
